export class CreateEditStoreModel {
  programKey = '';
  name = '';
}
